import { Navigate } from '@tanstack/react-router';
import { AnalyticsSupportedSocialMediaType } from '@anytag/shared-types';
import { useAnalyticsProfileContext } from '../analytics-profile-context';
import { AnalyticsTrendingYoutubePosts } from './analytics-trending-youtube-posts';

export const AnalyticsTrend = () => {
  const {
    selectedSocialAccount,
    brandAccount: { subscriptionPlan }
  } = useAnalyticsProfileContext();

  if (!subscriptionPlan.availableFeatures?.trendEnabled) {
    return <Navigate to="/analytics" />;
  }

  // Analytics just support youtube trending posts for now. We might have others later
  switch (selectedSocialAccount.socialMedia) {
    case AnalyticsSupportedSocialMediaType.youtube:
      return <AnalyticsTrendingYoutubePosts />;
    default:
      return <Navigate to="/analytics" />;
  }
};
